/**
 * rest 请求配置
 */
export default {
  DNS: 'https://0424bbc2629547e7ada5f0c8127c589c@sentry.lixinio.com/135',
  config: {
    release: '1.0.8',
    logger: 'javascript',
    ignoreUrls: [/sentry\.cheanjiait\.com/],
    environment: process.env.NODE_ENV
  }
}



// WEBPACK FOOTER //
// ./src/report/config.js